import {
	getDoubleFeatureFirstImage,
	getDoubleFeatureSecondImage,
} from './components/assets/localized-images';
import { JswDoubleFeatureCard } from './components/double-feature-card';

import { css } from '@compiled/react';

import { useIntl } from 'react-intl';

import { media } from '@atlaskit/primitives/responsive';
import { wacToken } from '@/libraries/design/foundations';

export const JswDoubleFeatureSection = () => {
	const intl = useIntl();
	const doubleFeatureItems = [
		{
			title: intl.formatMessage({
				id: 'jira-product-tour.double-feature-section.first-card-title-text',
				defaultMessage: 'Easily see every team’s progress',
			}),
			description: intl.formatMessage({
				id: 'jira-product-tour.double-feature-section.first-card-description-text',
				defaultMessage:
					'Track every team’s work in a single timeline. Understand progress, map dependencies, and stay ahead of risks.',
			}),
			image: getDoubleFeatureFirstImage(intl.locale),
		},
		{
			title: intl.formatMessage({
				id: 'jira-product-tour.double-feature-section.second-card-title-text',
				defaultMessage: 'Map work to company impact',
			}),
			description: intl.formatMessage({
				id: 'jira-product-tour.double-feature-section.second-card-description-text',
				defaultMessage:
					'With goals in Jira, it’s easy to track all the tasks across projects that contribute to a goal, no matter what team is working on it.',
			}),
			image: getDoubleFeatureSecondImage(intl.locale),
		},
	];

	return (
		<div css={containerStyles}>
			<h2 css={titleStyles}>
				{intl.formatMessage({
					id: 'jira-product-tour.double-feature-section.title-text',
					defaultMessage: 'Never lose sight of the big picture',
				})}
			</h2>
			<div css={cardContainerStyles}>
				{doubleFeatureItems.map((item, index) => (
					<JswDoubleFeatureCard
						key={index}
						title={item.title}
						description={item.description}
						image={item.image}
					/>
				))}
			</div>
			<div css={blackShapeStyles} />
		</div>
	);
};

JswDoubleFeatureSection.displayName = 'JswDoubleFeatureSection';

const containerStyles = css({
	display: 'grid',
	[media.below.lg]: {
		padding: '5% 0 0 0',
	},
});

const titleStyles = css({
	color: wacToken('color.primary.black'),
	textAlign: 'center',
	fontFamily: wacToken('font.charlie.display'),
	fontSize: '40px',
	fontWeight: '700',
	lineHeight: '48px',
	margin: 0,
	[media.below.lg]: {
		fontSize: '30px',
		padding: '0 25px 0 25px',
	},
});

const cardContainerStyles = css({
	display: 'flex',
	justifyContent: 'center',
	gap: '30px',
	padding: '34px 0px 25px 0px',
	[media.below.lg]: {
		flexDirection: 'column',
		alignItems: 'center',
		gap: '32px',
		padding: '34px 10% 25px 10%',
	},
});

const blackShapeStyles = css({
	clipPath: 'polygon(0 15%, 100% 0, 100% 100%, 0% 100%)',
	// eslint-disable-next-line local/ensure-wac-token-usage
	background: '#000',
	height: '250px',
	zIndex: '-1',
	marginBlockStart: '-150px',
});
